import { Box, Divider, Flex, Icon, IconButton, Menu, MenuButton, MenuItem, MenuList, Table, Tbody, Td, Text, Tfoot, Th, Thead, Tr } from "@chakra-ui/react";
import { FiMoreVertical } from 'react-icons/fi';
import { MdArrowDropDown, MdArrowDropUp } from 'react-icons/md';

import { useAuth } from "../../../hooks/auth";
import { ClassifDTO } from "../../../dtos/ClassifDTO";

type SortData = {
	por: string;
	cres: boolean;
};
type ControlsData = {
	page: number;
	perPage: number;
	totalPage: number;
};

interface DTTableParams {
	classifs: ClassifDTO[];
	pesqClassifs: ClassifDTO[];
	sort: SortData;
	setSort: (sort: SortData) => void;
	controls: ControlsData;
	handleUpdateList: (page: number, perPage: number, finans: ClassifDTO[]) => void;
	setModalClassifVisible: (param: boolean) => void;
	setClassifModal: (param: ClassifDTO) => void;
	onOpenAlertDelete: () => void;
};

const DTTable: React.FC<DTTableParams> = ({
	classifs,
	pesqClassifs,
	sort,
	setSort,
	controls,
	handleUpdateList,
	setModalClassifVisible,
	setClassifModal,
	onOpenAlertDelete
}) => {
	const { permissions } = useAuth();

	function handleSort(prop: string) {
		let mapped: ClassifDTO[] = [];

		const auxCres = !sort.cres;

		if (sort.por === prop) {
			if (auxCres) {
				mapped = pesqClassifs.sort((a, b) => {
					return (
						+(Object(a)[prop] > Object(b)[prop]) ||
						+(Object(a)[prop] === Object(b)[prop]) - 1
					);
				});
			} else {
				mapped = pesqClassifs.sort((a, b) => {
					return (
						+(Object(a)[prop] < Object(b)[prop]) ||
						+(Object(a)[prop] === Object(b)[prop]) - 1
					);
				});
			}
			setSort({ ...sort, cres: auxCres });
		} else {
			mapped = pesqClassifs.sort((a, b) => {
				return (
					+(Object(a)[prop] > Object(b)[prop]) ||
					+(Object(a)[prop] === Object(b)[prop]) - 1
				);
			});
			setSort({ por: prop, cres: true });
		}

		// setSort({ por: prop, cres: !sort.cres });

		handleUpdateList(1, controls.perPage, mapped);
	};

	return (
		<Table colorScheme="blackAlpha" size="sm" whiteSpace="nowrap">
			<Thead>
				<Tr>
					<Th cursor="pointer" onClick={() => handleSort('nome')}>
						<Flex align="center">
							Nome
							{sort.por === 'doc' && sort.cres ? (
								<Icon as={MdArrowDropUp} fontSize="20" />
							) : (
								sort.por === 'doc' &&
								!sort.cres && <Icon as={MdArrowDropDown} fontSize="20" />
							)}
						</Flex>
					</Th>

					<Th cursor="pointer" onClick={() => handleSort('empcod')}>
						<Flex justifyContent="flex-start">
							Empresa
							{sort.por === 'phone' && sort.cres ? (
								<Icon as={MdArrowDropUp} fontSize="20" />
							) : (
								sort.por === 'phone' &&
								!sort.cres && <Icon as={MdArrowDropDown} fontSize="20" />
							)}
						</Flex>
					</Th>

					<Th cursor="pointer" onClick={() => handleSort('ativsn')}>
						<Flex>
							Ativo
							{sort.por === 'cid' && sort.cres ? (
								<Icon as={MdArrowDropUp} fontSize="20" />
							) : (
								sort.por === 'cid' &&
								!sort.cres && <Icon as={MdArrowDropDown} fontSize="20" />
							)}
						</Flex>
					</Th>

					{(permissions.incluir || permissions.alterar) && (
						<Th></Th>
					)}
				</Tr>
			</Thead>

			<Tbody>
				{classifs.map(classif => {
					return (
						<Tr
							key={classif.id_classif}
							fontSize={14}
							fontWeight={500}
							cursor="pointer"
						>
							<Td py={2} cursor="pointer">
								<Box>
									<Text color="blue.500" fontSize={15}>
										{classif.nome === "" ? "--" : classif.nome}
									</Text>
									<Text color="gray.500" fontSize={10}>
										{classif.id_classif}
									</Text>
								</Box>
							</Td>

							<Td py={2} cursor="pointer">
								<Box>
									<Text color="gray.500">
										{!classif.empcod ? "--" : classif.empcod}
									</Text>
								</Box>
							</Td>

							<Td py={2} color="gray.500">
								{classif.ativsn === 'S' ? 'Ativo' : 'Inativo'}
							</Td>

							{(permissions.alterar || permissions.alterar) && (
								<Td py={1} px={1}>
									<Menu>
										{({ isOpen }) => (
											<>
												<MenuButton
													border={0}
													fontSize="1.5626rem"
													as={IconButton}
													isActive={isOpen}
													aria-label="Options"
													icon={<FiMoreVertical />}
													variant="outline"
													_hover={{ bg: 'gray.50' }}
												/>

												<MenuList p={0} boxShadow='xl'>
													<MenuItem
														fontSize={16}
														fontWeight={500}
														py={3}
														_hover={{ bg: 'gray.50' }}
														isDisabled
													>
														Detalhes
													</MenuItem>

													{permissions.alterar && (
														<>
															<Divider />

															<MenuItem
																fontSize={16}
																fontWeight={500}
																py={3}
																_hover={{ bg: 'gray.50' }}
																onClick={() => {
																	setClassifModal(classif);
																	setModalClassifVisible(true);
																}}
															>
																Editar
															</MenuItem>
														</>
													)}

													{permissions.excluir && (
														<>
															<Divider />

															<MenuItem
																fontSize={16}
																fontWeight={500}
																py={3}
																_hover={{ bg: 'gray.50' }}
																onClick={() => {
																	setClassifModal(classif);
																	onOpenAlertDelete();
																}}
															>
																Excluir
															</MenuItem>
														</>
													)}
												</MenuList>
											</>
										)}
									</Menu>
								</Td>
							)}
						</Tr>
					);
				})}
			</Tbody>

			<Tfoot>
				<Tr>
					<Th></Th>
					<Th></Th>
					<Th></Th>
					<Th></Th>
					<Th></Th>
				</Tr>
			</Tfoot>
		</Table>
	);
};

export default DTTable;